import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { Role } from '@classes/role';
import { NameToRole } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from 'app/core/services/account.service';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';
import { RoleService } from 'app/core/services/role.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
// import { environment } from '@environments/environment';

@Component({
  selector: 'app-role-list',
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss']
})
export class RoleListComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  value: string;
  @Input() set control(ctr: FormControl | null) {
    if (ctr) {
      this.myControl = ctr;
      this.value = ctr.value.id;
    }
  }
  @Input() placeHolder: string;
  @Input() displayAddButton: boolean = false;

  myControl!: FormControl;

  roles: Role[] = [];
  filteredRoles: Observable<Role[]> | undefined;

  constructor(
    public roleService: RoleService,
    public translateService: TranslateService,
    private accountService : AccountService,
    public envConfigurationService: EnvConfigurationService
  ) {
    this._initList();
  }

  ngOnInit() {
  }

  private _initList() {
    this.roleService.getRoles().subscribe(roles => {
      roles.forEach(role => {
        role.name_ = this.translateService.instant('label.role-' + role?.name + '-' + this.environment.application);
      });
      this.roles = roles
        .filter(f => this.roleService
          .getSelectableRoleByUserRole(this.accountService.currentUser.value?.role_)
          .find(fi => NameToRole.get(f.name || '') == fi) != null
          )
        .sort((a, b) =>
          ((a?.name || "").toLowerCase() > (b?.name || "").toLowerCase()) ? 1 : (((b?.name || "").toLowerCase() > (a?.name || "").toLowerCase()) ? -1 : 0));
      // this._initFilteredRoles();
      this.myControl.setValue(this.roles.find(f => f.id == this.value));
      this.myControl.updateValueAndValidity();
    }, error => {
      console.error(error);
    })
  }

  private _initFilteredRoles(): void {
    if (this.myControl) {
      this.filteredRoles = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => {
            if (typeof value === 'string') {
              return this._filter(value);
            }
            return []
          })
        );
    }
  }

  private _filter(value: string): Role[] {
    const filterValue = value.toLowerCase();
    return this.roles.filter(option =>
      (option.name_ || '').toLowerCase().includes(filterValue));
  }

  displayFn(role?: Role): string {
    if (role) {
      return role.name_ || '';
    }
    return '';
  }

  // createRole() {
  //   const data = null;
  //   const dialogRef = this.dialog.open(RoleDetailComponent, {
  //     data,
  //     hasBackdrop: true
  //   });
  //   dialogRef.afterClosed().subscribe(success => {
  //     if (success) {
  //       this._initList();
  //     }
  //   });
  // }

}
